export default __webpack_public_path__ + "static/media/next-hybridshellkeychain.5220897f.jpg";